<template>
	<div class="v-radio-group" ref="input">
		<slot/>
	</div>
</template>


<script>
export default {
  props: {
    value: {
      default() {
        return [];
      }
    }
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
        this.$emit("change", value);
      }
    }
  }
};
</script>

<style lang="less">
.v-radio-group {
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/vue-ext/components/radio/group.vue